import React from 'react';
import { Menu } from 'antd';
import { IconCompass } from '@tabler/icons-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TRANSLATIONS } from '../../constants/translations';
import { translate } from '../../helpers/translationHelper';

interface HeavyDutyMachineryNavMenuProps {
  mode: 'horizontal' | 'inline';
  onNavigate?: () => void;
}

const getSelectedKey = (pathname: string): string => {
  if (pathname === '/heavy-duty-machinery' || /^\/heavy-duty-machinery\/[^/]+$/.test(pathname)) return 'explore';
  return '';
};

const HeavyDutyMachineryNavMenu: React.FC<HeavyDutyMachineryNavMenuProps> = ({ mode, onNavigate }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  // One entry. Everything else moved behind the header's own grid icon (see
  // HostToolsMenu and HOST_TOOLS_NAV), Reservas included -- nine top-level
  // links was a menu bar nobody read, and Explorar is the one thing a
  // visitor with no account yet has any use for.
  //
  // "Reservas entrantes" is not hidden either: it is a tab inside Reservas
  // (see MyBookings' guest/host toggle), which is how the phone has always
  // shown it. The unseen badge moved onto the grid icon with it.
  const items = [
    {
      key: 'explore',
      icon: <IconCompass size={16} />,
      label: translate(t, TRANSLATIONS.HEAVY_DUTY_MACHINERY_NAV_EXPLORE),
      onClick: () => {
        navigate('/heavy-duty-machinery');
        onNavigate?.();
      },
    },
  ];

  return (
    <Menu
      mode={mode}
      selectedKeys={[getSelectedKey(location.pathname)]}
      items={items}
      style={mode === 'horizontal' ? { border: 'none', minWidth: 0, flex: 1 } : undefined}
    />
  );
};

export default HeavyDutyMachineryNavMenu;
